import { CardBackground, Typography } from "@hellocarbo/lasagne";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { data, useFetcher } from "react-router";

import { PendingResources } from "./PendingResources";
import Resources from "./Resources";
import ViewAllResourcesModal from "./ViewAllResourcesModal";

export async function loader() {
  const resourcesResponse = await fetch(`/api/client/onboarding_resources`);

  if (resourcesResponse.status == 403) {
    return { error: "No resources available" };
  }

  if (resourcesResponse.status !== 200) {
    throw data("Failed to load resources data", {
      status: resourcesResponse.status,
    });
  }

  const { data: resourcesData } = await resourcesResponse.json();

  return {
    resources: resourcesData?.resources,
  };
}

const OnboardingResourcesSection = () => {
  const { t } = useTranslation("onboarding");
  const fetcher = useFetcher();

  useEffect(() => {
    fetcher.submit({}, { action: "/onboarding/resource-data", method: "get" });
  }, []);

  if (fetcher.data?.error === "No resources available") {
    return null;
  }

  return (
    <CardBackground className="col-span-3">
      <div className="flex items-baseline justify-between">
        <Typography step="2" as="h2" weight="bold" className="mb-sm">
          {t("resources.title")}
        </Typography>
        <ViewAllResourcesModal />
      </div>
      {fetcher.state === "loading" ? (
        <PendingResources />
      ) : (
        <Resources resources={fetcher.data?.resources} />
      )}
    </CardBackground>
  );
};

export default OnboardingResourcesSection;
